import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { InnerBlocks } from '@wordpress/block-editor';
/**
 * Internal dependencies
 */

import socialList from '../social-link/social-list';
var ALLOWED_BLOCKS = Object.keys(socialList).map(function (site) {
  return 'core/social-link-' + site;
}); // Template contains the links that show when start.

var TEMPLATE = [['core/social-link-wordpress', {
  url: 'https://wordpress.org'
}], ['core/social-link-facebook'], ['core/social-link-twitter'], ['core/social-link-instagram'], ['core/social-link-linkedin'], ['core/social-link-youtube']];
export var SocialLinksEdit = function SocialLinksEdit(_ref) {
  var className = _ref.className;
  return createElement("div", {
    className: className
  }, createElement(InnerBlocks, {
    allowedBlocks: ALLOWED_BLOCKS,
    templateLock: false,
    template: TEMPLATE
  }));
};
export default SocialLinksEdit;
//# sourceMappingURL=edit.js.map